import React from "react";
import "react-circular-progressbar/dist/styles.css";
import {
    ProgressBarWrapper,
    SemiCircleText,
    Legend,
    HeaderContainer,
    IconWrapper,
    OccupancyText,
    CardContainer,
    HorseshoeSvg,
} from "./OccupancyRateCard.styles";

const OccupancyRateCard = ({ occupancyRate = 78 }) => {
    const arcLength = Math.PI * 40; // 半圓弧長度
    return (
        <CardContainer>
            <HeaderContainer>
                <OccupancyText>Occupancy Rate</OccupancyText>
                <IconWrapper />
            </HeaderContainer>
            <Legend>
                <span>● Occupied</span>
                <span>● Available</span>
            </Legend>
            <ProgressBarWrapper>
                <HorseshoeSvg>
                    <svg viewBox="0 0 100 50">
                        {/* 背景軌道 */}
                        <path
                            d="M 10 50 A 40 40 0 1 1 90 50"
                            fill="none"
                            stroke="rgba(114, 125, 135, 0.1)"
                            strokeWidth="8"
                            strokeLinecap="round"
                        />
                        {/* 進度條 */}
                        <path
                            d="M 10 50 A 40 40 0 1 1 90 50"
                            fill="none"
                            stroke="#61CBC9"
                            strokeWidth="8"
                            strokeDasharray={`${(occupancyRate / 100) * arcLength} ${(1 - occupancyRate / 100) * arcLength}`}
                            strokeLinecap="round"
                        />
                    </svg>
                    <SemiCircleText>{`${occupancyRate}%`}</SemiCircleText>
                </HorseshoeSvg>
            </ProgressBarWrapper>
        </CardContainer>
    );
};

export default OccupancyRateCard;
